// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Fira+Code:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Fira Code', monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: 'Fira Code', monospace;
}

a {
  text-decoration: none !important;
}

img {
  max-width: 100%;
  height: 100%;
}

main>.container {
  padding:0;
}

span>img{
  height: 300px;
  width: 300px;
}

.albumGrid {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  padding: 2rem 0 2rem 0;
}

.backButton {
  font-family: 'Fira Code', monospace;
  border: none;
  background-color: #f8f8f8;
  font-size: 1.25rem;
  cursor: pointer;
}

.backButton:hover {
  text-shadow:
  -.25px -.25px 0 black,
  .25px -.25px 0 black,
  -.25px .25px 0 black,
  .25px .25px 0 black;
  transition: all .15s;
}

.albumImage {
  display: block;
  width: 300px;
  height: 300px;
}

.albumTitle {
  color: black;
  font-size: 25px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.card, .card-header, .card-footer {
  background-color: #f8f8f8;
}

.card-img {
  width: 250px;
  height: 250px;
}

.figure-img {
  width: 256px;
  height: 171px;
}

.footer {
  margin: 4rem 0 1rem 0;
  text-align: center;
  font-size: .75rem;
}

.imgCell {
  position: relative;
}

.imgCell:hover .overlay {
  opacity: 0.85;
}

.list-group-item {
  background-color:#f8f8f8;
}

.navbar-brand {
  font-size: 1.55rem !important;
}

.newsLink {
  color: #FF5858;
  text-decoration: none;
}

.newsLink:visited {
  color: #FF5858;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: .5s ease;
  background-color: #f7f7f7;
}

/* Bounce In */
.hvrBounceIn {
  margin: 0;
  display: inline-block;
  vertical-align: middle;
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  transition-duration: 0.5s;
}

.hvrBounceIn:hover, .hvrBounceIn:focus, .hvrBounceIn:active {
  transform: scale(1.7);
  transition-timing-function: cubic-bezier(0.47, 2.02, 0.31, -0.36);
}

@media screen and (min-width: 650px) {

  main>.container {
    padding-left: 15px;
    padding-right: 15px;
  }

  .albumGrid {
    flex-direction: row;
}

  .card {
    width: 75%;
  }

  .card-img{
    width: 350px;
    height: 350px;
  }

  .figure-img {
    width: 512px;
    height: 341.25px;
  }

  .navbar-brand {
    font-size: 2rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;;;;qBAImB;EAInB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAGT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,SAAS;EACT,qBAAqB;EACrB,sBAAsB;EAEtB,yCAAyC;EACzC,oCAAoC;EAEpC,yBAAyB;AAC3B;;AAEA;EAEE,qBAAqB;EAErB,iEAAiE;AACnE;;AAEA;;EAEE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;AACvB;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@300;400;500;600;700&display=swap');\n\nbody {\n  margin: 0;\n  font-family: 'Fira Code', monospace;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: 'Fira Code', monospace;\n}\n\na {\n  text-decoration: none !important;\n}\n\nimg {\n  max-width: 100%;\n  height: 100%;\n}\n\nmain>.container {\n  padding:0;\n}\n\nspan>img{\n  height: 300px;\n  width: 300px;\n}\n\n.albumGrid {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  align-items: center;\n  padding: 2rem 0 2rem 0;\n}\n\n.backButton {\n  font-family: 'Fira Code', monospace;\n  border: none;\n  background-color: #f8f8f8;\n  font-size: 1.25rem;\n  cursor: pointer;\n}\n\n.backButton:hover {\n  text-shadow:\n  -.25px -.25px 0 black,\n  .25px -.25px 0 black,\n  -.25px .25px 0 black,\n  .25px .25px 0 black;\n  -webkit-transition: all .15s;\n  -moz-transition: all .15s;\n  -o-transition: all .15s;\n  transition: all .15s;\n}\n\n.albumImage {\n  display: block;\n  width: 300px;\n  height: 300px;\n}\n\n.albumTitle {\n  color: black;\n  font-size: 25px;\n  font-weight: 500;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.card, .card-header, .card-footer {\n  background-color: #f8f8f8;\n}\n\n.card-img {\n  width: 250px;\n  height: 250px;\n}\n\n.figure-img {\n  width: 256px;\n  height: 171px;\n}\n\n.footer {\n  margin: 4rem 0 1rem 0;\n  text-align: center;\n  font-size: .75rem;\n}\n\n.imgCell {\n  position: relative;\n}\n\n.imgCell:hover .overlay {\n  opacity: 0.85;\n}\n\n.list-group-item {\n  background-color:#f8f8f8;\n}\n\n.navbar-brand {\n  font-size: 1.55rem !important;\n}\n\n.newsLink {\n  color: #FF5858;\n  text-decoration: none;\n}\n\n.newsLink:visited {\n  color: #FF5858;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0;\n  transition: .5s ease;\n  background-color: #f7f7f7;\n}\n\n/* Bounce In */\n.hvrBounceIn {\n  margin: 0;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-transform: perspective(1px) translateZ(0);\n  transform: perspective(1px) translateZ(0);\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0);\n  -webkit-transition-duration: 0.5s;\n  transition-duration: 0.5s;\n}\n\n.hvrBounceIn:hover, .hvrBounceIn:focus, .hvrBounceIn:active {\n  -webkit-transform: scale(1.7);\n  transform: scale(1.7);\n  -webkit-transition-timing-function: cubic-bezier(0.47, 2.02, 0.31, -0.36);\n  transition-timing-function: cubic-bezier(0.47, 2.02, 0.31, -0.36);\n}\n\n@media screen and (min-width: 650px) {\n\n  main>.container {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  .albumGrid {\n    flex-direction: row;\n}\n\n  .card {\n    width: 75%;\n  }\n\n  .card-img{\n    width: 350px;\n    height: 350px;\n  }\n\n  .figure-img {\n    width: 512px;\n    height: 341.25px;\n  }\n\n  .navbar-brand {\n    font-size: 2rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
